export { default as OwnerAccessRestricted } from './OwnerAccessRestricted'
